export default __webpack_public_path__ + "static/media/234.456288a5.jpg";